import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';

import asyncComponent from '../../../util/asyncComponent';


const VehicleMaintenance = ({match}) => (
    <div className="app-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/dashboard`}/>
            <Route path={`${match.url}/dashboard`} component={asyncComponent(() => import('./routes/Dashboard'))}/>
            <Route path={`${match.url}/service-reminder`} component={asyncComponent(() => import('./routes/ServiceReminder'))}/>
            <Route path={`${match.url}/service-type`} component={asyncComponent(() => import('./routes/ServiceType'))}/>
            <Route path={`${match.url}/spare-part`} component={asyncComponent(() => import('./routes/SparePart'))}/>
            <Route path={`${match.url}/vehicle-disposal`} component={asyncComponent(() => import('./routes/VehicleDisposal'))}/>
            <Route path={`${match.url}/vehicle-transfer`} component={asyncComponent(() => import('./routes/VehicleTransfer'))}/>
            <Route path={`${match.url}/vehicle-writeoff`} component={asyncComponent(() => import('./routes/VehicleWriteOff'))}/>
            <Route path={`${match.url}/work-order`} component={asyncComponent(() => import('./routes/WorkOrder'))}/>
            <Route path={`${match.url}/workshop`} component={asyncComponent(() => import('./routes/Workshop'))}/>
            <Route component={asyncComponent(() => import('components/Error404'))}/>
        </Switch>
    </div>
);

export default VehicleMaintenance;


// WEBPACK FOOTER //
// ./app/routes/VehicleMaintenance/index.js